<template>
  <div>
    <div v-for="(line, i) in basket.lines" :key="i" class="basket-lines">
      <div class="line-name">
        {{ line.name }}
      </div>
      <!--      <div class="line-qty">
        {{ line.qty_items }}
      </div>
      <div class="line-price">
        {{ line.price }}
      </div>-->
      <div class="line-total">
        {{ line.line_total }}
      </div>
      <div class="line-action">Veiksmai</div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    basket() {
      return this.$store.state.basket
    },
  },
}
</script>
